import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import { makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  descriptionBox: {
    display: "flex",
    flexDirection: "column",
    alignContent: "center",
    alignItems: "center",
  },
  BtnBox: {
    display: "flex",
    width: "100%",
    justifyContent: "center",
    paddingBottom: "10px",
    marginTop: "20px",
  },
  cancelBtn: {
    padding: "6px 20px",
    fontFamily: "Poppins",
    color: "#FF712D",
    width: "110px",
    height: "41px",
    background: "#FFFFFF",
    borderRadius: "6px",
    border: "1px solid #FF712D",
    fontStyle: "normal",
    fontWeight: "500",
    fontSize: "16px",
    lineHeight: "19px",
    textTransform: "none",
    "&:focus": {
      outline: "none !important",
    },
  },
  steps: {
    width: "50%",
    textAlign: "left",
    marginTop: "5px",
  },
}));

const DisabledNotification = ({ open, closeModalHandler }) => {
  const classes = useStyles();

  return (
    <>
      <Dialog open={open} fullWidth="md">
        <DialogTitle>
          <div className="text-center"> Notifications Blocked </div>
        </DialogTitle>
        <div className={classes.descriptionBox}>
          <Typography className={classes.steps}>
            You have blocked the notifications. Please reset permissions to
            enable it again
          </Typography>
        </div>
        <DialogActions>
          <div className={classes.BtnBox}>
            <Button
              className={classes.cancelBtn}
              onClick={() => closeModalHandler(false)}
            >
              Close
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default DisabledNotification;
